export const AUDIT_MODULES = [
  "HR", "LEAVE", "PAYROLL", "ATTENDANCE", "NOTIFICATION", "SECURITY",
  "REFERENCE_DATA", "WORKFLOW", "SYSTEM", "MEMBERSHIP", "PROCUREMENT",
  "TRAINING", "CLAIM", "INVENTORY", "REQUISITION", "CALENDAR", "DOCUMENT",
] as const;
export type AuditModule = (typeof AUDIT_MODULES)[number];

export const AUDIT_ACTIONS = [
  "CREATED", "UPDATED", "DELETED", "ACTIVATED", "DEACTIVATED", "SUBMITTED",
  "APPROVED", "REJECTED", "CANCELLED", "LOGIN_SUCCESS", "LOGIN_FAILED",
  "PASSWORD_RESET_REQUESTED", "PASSWORD_CHANGED", "ROLE_ASSIGNED",
  "ROLE_REMOVED", "PERMISSION_ASSIGNED", "PERMISSION_REMOVED", "EXPORTED",
  "IMPORTED", "VIEWED", "PAID", "DISBURSED", "SYSTEM_EVENT",
] as const;
export type AuditAction = (typeof AUDIT_ACTIONS)[number];

export type AuditEvent = {
  id: number;
  module: AuditModule;
  action: AuditAction;
  entityType?: string | null;
  entityId?: number | null;
  entityReference?: string | null;
  actorUserId?: number | null;
  actorUsername?: string | null;
  summary?: string | null;
  details?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
  requestId?: string | null;
  eventAt: string;
};

export type AuditEventPageResponse = {
  content: AuditEvent[];
  number: number;
  size: number;
  totalElements: number;
  totalPages: number;
  first?: boolean;
  last?: boolean;
};

export type AuditSearchFilters = {
  module?: AuditModule | "";
  action?: AuditAction | "";
  entityType?: string;
  entityId?: number;
  actorUserId?: number;
  from?: string;
  to?: string;
};

/** A searchable user option returned by the actor autocomplete. */
export type AuditActorOption = {
  id: number;
  name: string;
  username: string;
};
